'use client';

import { ExclusiveFuseupSection as FuseupSectionUI } from '@wwe-portal/widget/club-store';

import {
  FuseupDialog,
  useFuseupDialog,
} from '@wwe-portal/web/components/club-store/modals/fuseup-dialog';

import { useRosterListSize } from '@wwe-portal/web/utils/club-store/helper';
import { parseRosterItemToProps } from '@wwe-portal/web/utils/club-store/mapper';
import { useRosterItems } from '../../providers/queries/club-store';
import {
  useSelectRoster,
  useRosterFilter,
} from '../../hooks/club-store/use-roster-filter';
import { Dialog, usePortableDialog } from '@wwe-portal/ui/components/dialog';
import { useTranslations } from 'next-intl';
import { useSubscriptionMutation } from '@wwe-portal/web/providers/queries/subscription.mutation';
import { useSubscriptionQuery } from '@wwe-portal/web/providers/queries/subscription';
import { ChangePlanDialog } from '@wwe-portal/ui/features/subscription/dialog';

export const FuseUpSection = () => {
  const { currentPlan } = useSubscriptionQuery();
  const { mutation, upgradeDialogState } = useSubscriptionMutation({
    currentPlan,
  });
  const pageSize = useRosterListSize();
  const { data: rosterItemResponse, isLoading: isLoadingRosters } =
    useRosterItems();

  const allData = rosterItemResponse?.data.data
    .map(parseRosterItemToProps)
    .filter((item) => item.id);

  const rosters = allData?.slice(0, pageSize);
  const total = rosterItemResponse?.data.data.length;

  const fuseupModal = usePortableDialog(FuseupDialog);
  const t = useTranslations();

  const { roster, selectRosterById, clearSelection } = useSelectRoster({
    rosters: allData ?? [],
    onSelected: () => {
      fuseupDialog.show();
    },
  });

  const {
    show: showRosterFilter,
    remove: hideRosterFilter,
    dialog,
  } = useRosterFilter({
    title: 'CURRENT ROSTER',
    onClickRoster: selectRosterById,
    hidden: fuseupModal.visible,
    playerRosters: allData ?? [],
    id: 'fuse-up-filter',
  });

  const fuseupDialog = useFuseupDialog({
    currentRoster: roster,
    hideRosterFilter,
    onClose: clearSelection,
    subsribeMutation: mutation,
  });

  return (
    <>
      <FuseupSectionUI
        title={t('clubStore_fuseUp_title')}
        description={t('clubStore_fuseUp_description')}
        isLoading={isLoadingRosters}
        rosters={rosters}
        total={total}
        onItemClick={selectRosterById}
        onViewMoreRosters={showRosterFilter}
      />

      {dialog}
      {fuseupDialog.dialog}

      {upgradeDialogState ? (
        <Dialog
          onOpenChange={(value) => {
            if (!value) {
              upgradeDialogState.onClose();
            }
          }}
          open
        >
          <ChangePlanDialog
            buttonContent={upgradeDialogState.buttonContent}
            description={upgradeDialogState.description}
            isUpgrading={mutation.isLoading}
            onChange={upgradeDialogState.onChange}
            onClose={upgradeDialogState.onClose}
          />
        </Dialog>
      ) : null}
    </>
  );
};
